<div class="bg-col-w">
    <div class="wrap p-a">
        <ng-content></ng-content>
    </div>
</div>
